"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _StoreComponent2 = _interopRequireDefault(require("../../../KESI2/Stores/StoreComponent"));

var _FeedbackReceiveStore = _interopRequireWildcard(require("../../../KESI2/Services/FeedbackService/Stores/FeedbackReceiveStore2"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var FeedbackStore = /*#__PURE__*/function (_StoreComponent) {
  (0, _inherits2["default"])(FeedbackStore, _StoreComponent);

  var _super = _createSuper(FeedbackStore);

  function FeedbackStore(props) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, FeedbackStore);
    _this = _super.call(this, props);
    _this.state = {
      answerStats: {}
    };
    _this.storeKeys = [_FeedbackReceiveStore.FEEDBACK_RECEIVE_STORE_PATHS.DATA_INITIALIZED, _FeedbackReceiveStore.FEEDBACK_RECEIVE_STORE_PATHS.DATA_ERROR, _FeedbackReceiveStore.FEEDBACK_RECEIVE_STORE_PATHS.FEEDBACKS];

    _this.mapStoreToState = function (feedbackReceiveStore, newState) {
      if (!_this.storeKeys) return newState;
      var doUpdate = false;
      var updateObj = {};

      for (var i = 0; i < _this.storeKeys.length; i++) {
        var prop = _this.storeKeys[i];

        if (newState.hasOwnProperty(prop)) {
          doUpdate = true;
          updateObj[prop] = newState[prop];

          if (prop === _FeedbackReceiveStore.FEEDBACK_RECEIVE_STORE_PATHS.FEEDBACKS) {
            var feedBacks = newState[_FeedbackReceiveStore.FEEDBACK_RECEIVE_STORE_PATHS.FEEDBACKS];
            console.log(feedBacks);
            updateObj['answerStats'] = feedBacks;
          }
        }
      }

      return doUpdate ? updateObj : false;
    };

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(FeedbackStore.prototype)), "addStoresAndKeys", _thisSuper).call(_thisSuper, [{
      store: _FeedbackReceiveStore["default"],
      keys: _this.storeKeys
    }]);
    return _this;
  }

  (0, _createClass2["default"])(FeedbackStore, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if ((0, _stringify["default"])(prevState.answerStats) !== (0, _stringify["default"])(this.state.answerStats)) {
        console.log('componentDidUpdate', prevState, this.state.answerStats);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.render(this.state.answerStats);
    }
  }]);
  return FeedbackStore;
}(_StoreComponent2["default"]);

var _default = FeedbackStore;
exports["default"] = _default;